module.exports = __webpack_public_path__ + "img/revolut.81b697b9.svg";